module.exports = __webpack_public_path__ + "img/สาหร่ายเอสสปาเก็ตตี้.154997d6.jpg";